import { render, staticRenderFns } from "./atBox.vue?vue&type=template&id=9f44f42a&scoped=true&"
import script from "./atBox.vue?vue&type=script&lang=js&"
export * from "./atBox.vue?vue&type=script&lang=js&"
import style0 from "./atBox.vue?vue&type=style&index=0&id=9f44f42a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f44f42a",
  null
  
)

export default component.exports